import { render } from "./MaterialButton.vue?vue&type=template&id=d4a42e7c&scoped=true"
import script from "./MaterialButton.vue?vue&type=script&lang=js"
export * from "./MaterialButton.vue?vue&type=script&lang=js"

import "./MaterialButton.vue?vue&type=style&index=0&id=d4a42e7c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4a42e7c"]])

export default __exports__